<template>
  <v-card elevation="0">
    <v-layout v-if="type !== 'target'" justify-center pt-2>
      <div class="grey--text">{{ label }}</div>
    </v-layout>

    <image-uploader
      v-if="type === 'texture' || !imageUrl"
      :id="id"
      :preview="false"
      :className="['fileinput', { 'fileinput--loaded': hasImage }]"
      :maxWidth="this.type === 'mapPlan' ? 1024: 512"
      capture="environment"
      :accept="accept"
      doNotResize="['gif', 'svg']"
      :autoRotate="false"
      outputFormat="verbose"
      @input="change"
      :debug="2"
    >
      <label :for="id" slot="upload-label" v-if="type === 'texture' || !imageUrl ">
        <v-layout
          v-if="type === 'texture' || !imageUrl "
          :class="[
            quizzImage ? 'ImageInput__emptyField__quizz' : null,
            type === 'target' ? 'ImageInput__emptyField__target' : null,
            type === 'texture' ? 'ImageInput__emptyField__texture' : null,
            
            !quizzImage && type !== 'target' && type !== 'texture' ? 'ImageInput__emptyField' : null,
          ]"
        >
          <div> 
            <v-icon x-large color="primary">mdi-image</v-icon>
          </div>
        </v-layout>
      </label>
    </image-uploader>

    <v-layout v-if="imageUrl && type !== 'target' && type !== 'texture'" pt-2 class="showEdit">
      <v-flex>
      <v-img
        v-if="imageUrl"
        class="'ImageInput__image'"
        :src="imageUrl"
        :style="componentStyle"
        :height="height"
        :width="width"
      />
      </v-flex>
    </v-layout>

    <!-- image banner -->
    <v-card
      v-if="imageUrl && type !== 'target'"
      class="banner hide"
      elevation="0"
      color="rgba(230,230,230,0.7)"
    >
      <v-flex layout justify-center>
        <image-uploader
          :id="id"
          :preview="false"
          :className="['fileinput', { 'fileinput--loaded': hasImage }]"
          :maxWidth="512"
          capture="environment"
          :accept="accept"
          doNotResize="['gif', 'svg']"
          :autoRotate="false"
          outputFormat="verbose"
          @input="change"
          :debug="2"
        >
          <label :for="id" slot="upload-label">
            <v-icon medium color="primary" class="pointerClass"
              >mdi-pencil</v-icon
            >
          </label>
        </image-uploader>
        <v-menu max-height="50vh" :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-icon v-if="showImageInfos" v-on="on" medium color="primary"
              >mdi-information-outline</v-icon
            >
          </template>
          <v-card style="padding: 15px; width: 400px">
            <v-text-field
              :label="$t('media.copyright')"
              :counter="maxTextFieldsLength"
              v-model="author"
              @blur="updateImage"
            >
            </v-text-field>

            <v-text-field
              v-model="legend[langEdition]"
              :label="$t('media.caption')"
              :counter="maxTextFieldsLength"
              :hint="langEdition !== locale ? legend[locale] : null"
              :persistent-hint="showHint"
              @blur="updateImage"
            >
              <language-translator
                v-if="locale !== langEdition"
                :langEdition="langEdition"
                :textToTranslate="legend[locale]"
                :type="'legend'"
                @text-translated="updateTranslatedText"
                slot="append"
              >
              </language-translator>
            </v-text-field>
          </v-card>
        </v-menu>

        <v-icon medium color="red" @click="deleteImage()"> mdi-close</v-icon>
      </v-flex>
    </v-card>
  </v-card>
</template>

<script>
import axios from 'axios';
import LanguageTranslator from '../components/LanguageTranslator.vue';

export default {
  name: 'ImageInput',
  components: { LanguageTranslator },
  data: () => ({
    file: {},
    imageUrl: null,
    author: '',
    legend: { fr: '', en: '' },
    maxTextFieldsLength: 50,
    id:
      'fileInput_' +
      Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 5),
    accept: 'image/*',
  }),
  props: {
    index: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    height: {
      type: Number,
      default: 180,
    },
    width: {
      type: Number,
      default: 150,
    },
    tooltip: String,
    default: {
      type: Object,
      default: null,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
    quizzImage: {
      type: Boolean,
      default: false,
    },
    langEdition: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    imgKey: {
      type: Number,
      default: null,
    },
    parent: {
      type: String,
      default: null,
    },
    showImageInfos: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    console.log('image input', JSON.parse(JSON.stringify(this.default)));
    if (!this.default) {
      return;
    }
    this.imageUrl = this.default.url;
    this.author = this.default.author || '';
    this.legend.fr = (this.default.legend && this.default.legend.fr) || '';
    this.legend.en = (this.default.legend && this.default.legend.en) || '';
  },
  watch: {
    default() {
      if (this.default) {
        this.imageUrl = this.default.url || '';
        this.author = this.default.author || '';
        this.legend.fr = this.default.legend.fr || '';
        this.legend.en = this.default.legend.en || '';
      } else {
        this.imageUrl = '';
        this.author = '';
        this.legend = { fr: '', en: '' };
      }
    },
  },
  computed: {
    // imageUrl() {
    //   if (!this.default) {return null;}
    //   return this.default.url;
    // },
    // author() {
    //   if (!this.default || !this.default.author)
    //       return '';
    //   return this.default.author;
    // },
    // legend() {
    //   if (!this.default || !this.default.legend)
    //     return {fr:'',en:''};
    //   return this.default.legend
    // },

    accountId() {
      return this.$store.getters['accounts/currentAccount']._kuzzle_info
        .accountId;
    },
    locale() {
      return this.$i18n.locale;
    },
    hasImage() {
      return this.imageUrl && this.imageUrl.length > 0;
    },
    componentStyle() {
      return  this.type === 'mapPlan' ? { width: '300px', height: 'auto' } : null
      },
    
  },
  methods: {
    fileTypeCheck(type) {
      return type.split('/')[0] === this.accept.split('/')[0];
    },
    async dataUrlToFile(dataUrl, fileName, fileType) {
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      if (fileType.includes('svg')) {
        fileType = 'image/png';
      }
      return new File([blob], fileName, { type: fileType });
    },
    async change(file64) {
      if (!this.fileTypeCheck(file64.info.type)) {
        this.showError = this.$t('image.error.fileTypeError');
        return;
      }
      this.file = await this.dataUrlToFile(
        file64.dataUrl,
        file64.info.name,
        file64.info.type
      );
      if (file64.dataUrl.substring(0, 10).includes('data')) {
        file64.dataUrl = file64.dataUrl.split(',')[1];
      }
      const axiosOptions = {
        headers: {
          'Content-Type': this.file.type,
        },
      };

      try {
        const { result } = await this.$kuzzle.query({
          controller: 'explorama-plugin/s3',
          action: 'getUploadUrlStudio',
          uploadDir: 'contentPictures',
          accountId: this.accountId.split('-')[0],
          fileext: this.file.name.split('.').pop(),
        });
        await axios.put(result.uploadUrl, this.file, axiosOptions);

        let imagePayload = {
          author: this.author,
          url: result.fileUrl,
          legend: this.legend,
        };
        if (this.parent === 'gameTakePicture') {
          imagePayload.dataUrl = file64.dataUrl;
        }

        if (this.imageUrl || this.parent === 'rewards') {
          this.$emit('change-image-input', imagePayload, this.imgKey);
        } else {
          this.$emit('change-image-input', imagePayload);
        }
        this.imageUrl = result.fileUrl;
      } catch (error) {
        this.$emit('error', error);
      }
    },
    deleteImage() {
      this.$emit(
        'change-image-input',
        { author: '', url: '', legend: { fr: '', en: '' } },
        this.imgKey
      );
    },

    updateTranslatedText(textTranslated, type) {
      if (textTranslated && type === 'legend') {
        this.legend[this.langEdition] = textTranslated;
        this.updateImage();
      }
    },
    updateImage() {
      this.$emit(
        'change-image-input',
        { author: this.author, url: this.imageUrl, legend: this.legend },
        this.imgKey
      );
    },
  },
};
</script>

<style scoped lang="sass">

.ImageInput__emptyField
  background: white
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  border-radius: 4px
  div
    width: 150px
    height: 180px
    border: 2px dashed #009999
    border-radius: 2px
    display: flex
    justify-content: center
    align-items: center

.ImageInput__emptyField__texture
  background: white
  cursor: pointer
  display: flex
  align-items: center
  border-radius: 4px
  margin-left: 10px;
  padding-right: 10px;
  div
    width: 110px
    height: 170px
    border: 2px dashed #009999
    border-radius: 2px
    display: flex
    justify-content: center
    align-items: center

.ImageInput__emptyField__quizz
  background: white
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  border-radius: 4px
  div
    width: 150px
    height: 90px
    border: 2px dashed #009999
    border-radius: 2px
    display: flex
    justify-content: center
    align-items: center

.ImageInput__emptyField__target
  background: white
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  border-radius: 4px
  padding-top: 0px

  div
    width: 200px
    height: 200px
    border: 2px dashed #009999
    border-radius: 2px
    display: flex
    justify-content: center
    align-items: center

.ImageInput__image
	pointer-events: none

.ImageInput__close
  position: absolute
  top: -12px
  left: -12px
  cursor: pointer

.ImageInput__wrapper
  position: relative
  border-radius: 4px

.hide
  display: none

.showEdit:hover + .hide
  display: block
  position: absolute
  over
  z-index: 10

.banner:hover
  display: block
  position: absolute
  over
  z-index: 10

.banner
  position: absolute
  top : 60%
  left: 50%
  transform: translate(-50%, -50%);
  width: 100%;
  color: rgba(0,0,0,0.3)

.pointerClass
  cursor: pointer
</style>
